(function(){
  var STORAGE_KEY='ccb_wishlist';
  var WISHLIST_URL='/pages/wishlist';

  var HEART_OUTLINE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  var HEART_FILLED='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  function getList(){
    try{ return JSON.parse(localStorage.getItem(STORAGE_KEY)||'[]'); }catch(e){ return []; }
  }
  function setList(items){
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('ccb:wishlist:changed',{detail:{items:items}}));
  }
  function isSaved(handle){ return getList().indexOf(handle)>=0; }
  function toggle(handle){
    var list=getList(); var i=list.indexOf(handle);
    if(i>=0){ list.splice(i,1); } else { list.push(handle); }
    setList(list);
    return list.indexOf(handle)>=0;
  }

  function syncAllHearts(handle, saved){
    var hearts=document.querySelectorAll('.ccb-heart[data-handle="'+handle+'"]');
    hearts.forEach(function(h){
      h.classList.toggle('is-saved', saved);
      h.innerHTML=saved?HEART_FILLED:HEART_OUTLINE;
      h.setAttribute('aria-label', saved?'Remove from wishlist':'Save to wishlist');
      h.setAttribute('title', saved?'Saved':'Save');
    });
    var pdp=document.querySelector('.ccb-pdp-wishlist[data-handle="'+handle+'"]');
    if(pdp){
      pdp.classList.toggle('is-saved', saved);
      var icon=saved?HEART_FILLED:HEART_OUTLINE;
      var label=saved?'Saved':'Save to wishlist';
      pdp.innerHTML=icon+'<span class="ccb-pdp-wishlist__label">'+label+'</span>';
    }
  }

  function makeHeart(handle){
    var saved=isSaved(handle);
    var btn=document.createElement('button');
    btn.type='button';
    btn.className='ccb-heart'+(saved?' is-saved':'');
    btn.setAttribute('data-handle',handle);
    btn.setAttribute('aria-label',saved?'Remove from wishlist':'Save to wishlist');
    btn.setAttribute('title',saved?'Saved':'Save');
    btn.innerHTML=saved?HEART_FILLED:HEART_OUTLINE;
    btn.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation();
      var nowSaved=toggle(handle);
      syncAllHearts(handle,nowSaved);
      btn.classList.add('ccb-heart--pulse');
      setTimeout(function(){ btn.classList.remove('ccb-heart--pulse'); },420);
    });
    return btn;
  }

  function injectCardHearts(){
    var cards=document.querySelectorAll('product-card:not([data-ccb-wished]), .product-card:not([data-ccb-wished])');
    cards.forEach(function(card){
      var link=card.querySelector('a.product-card__link, a[href*="/products/"]');
      if(!link) return;
      var href=link.getAttribute('href')||'';
      var m=href.match(/\/products\/([^/?#]+)/);
      if(!m) return;
      var handle=m[1];
      var wrap=document.createElement('div');
      wrap.className='ccb-heart-wrap';
      wrap.appendChild(makeHeart(handle));
      card.appendChild(wrap);
      card.setAttribute('data-ccb-wished','1');
    });
  }

  function injectPdpHeart(){
    var main=document.getElementById('MainContent');
    if(!main || main.getAttribute('data-template')!=='product') return;
    if(document.querySelector('.ccb-pdp-wishlist')) return;
    var m=window.location.pathname.match(/\/products\/([^/?#]+)/);
    if(!m) return;
    var handle=m[1];
    var anchor=document.querySelector('.buy-buttons-block, product-form-component, .product-form, .shopify-payment-button');
    if(!anchor) return;
    var saved=isSaved(handle);
    var btn=document.createElement('button');
    btn.type='button';
    btn.className='ccb-pdp-wishlist'+(saved?' is-saved':'');
    btn.setAttribute('data-handle',handle);
    btn.innerHTML=(saved?HEART_FILLED:HEART_OUTLINE)+'<span class="ccb-pdp-wishlist__label">'+(saved?'Saved':'Save to wishlist')+'</span>';
    btn.addEventListener('click',function(e){
      e.preventDefault();
      var nowSaved=toggle(handle);
      syncAllHearts(handle,nowSaved);
    });
    var parent=anchor.parentNode;
    var inserted=false;
    var siblings=parent.children;
    for(var i=0;i<siblings.length;i++){
      if(siblings[i]===anchor || anchor.contains(siblings[i]) || siblings[i].contains(anchor)){
        if(siblings[i].nextSibling){ parent.insertBefore(btn, siblings[i].nextSibling); }
        else { parent.appendChild(btn); }
        inserted=true; break;
      }
    }
    if(!inserted){ parent.appendChild(btn); }
  }

  function injectHeaderHeart(){
    if(document.querySelector('.ccb-header-wishlist')) return;
    var anchor=document.querySelector('cart-icon-component') ||
               document.querySelector('a[href="/cart"]') ||
               document.querySelector('.header__icons-cart') ||
               document.querySelector('[class*="header"] [class*="cart"]');
    if(!anchor) return;
    var link=document.createElement('a');
    link.href=WISHLIST_URL;
    link.className='ccb-header-wishlist';
    link.setAttribute('aria-label','Wishlist');
    link.innerHTML=HEART_OUTLINE+'<span class="ccb-header-wishlist__count" aria-hidden="true">0</span>';
    var target=anchor.closest('a, button, cart-icon-component') || anchor;
    target.parentNode.insertBefore(link, target);
    updateHeaderCount();
  }

  function updateHeaderCount(){
    var count=getList().length;
    document.querySelectorAll('.ccb-header-wishlist__count').forEach(function(el){
      el.textContent=count;
      el.style.display=count>0?'inline-flex':'none';
    });
  }

  function fmtPrice(cents, currency){
    var v=(cents/100);
    var formatted=v.toLocaleString(undefined,{minimumFractionDigits:0,maximumFractionDigits:0});
    return (currency||'EGP')+' '+formatted;
  }

  function renderWishlistPage(){
    var grid=document.getElementById('ccb-wishlist-grid');
    if(!grid) return;
    var empty=document.getElementById('ccb-wishlist-empty');
    var counter=document.getElementById('ccb-wishlist-counter');
    var handles=getList();

    if(counter){
      counter.textContent=handles.length+(handles.length===1?' piece':' pieces');
    }

    if(handles.length===0){
      if(empty) empty.style.display='block';
      grid.style.display='none';
      grid.innerHTML='';
      return;
    }
    if(empty) empty.style.display='none';
    grid.style.display='grid';
    if(!grid.dataset.loaded){ grid.innerHTML='<p style="opacity:0.5;text-align:center;padding:60px;font-family:Inter,sans-serif;font-size:12px;letter-spacing:0.18em;text-transform:uppercase">Loading…</p>'; }

    Promise.all(handles.map(function(h){
      return fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
    })).then(function(products){
      var valid=products.filter(function(p){return p!==null;});
      var validHandles=valid.map(function(p){return p.handle;});
      if(validHandles.length!==handles.length){ setList(validHandles); }
      if(valid.length===0){
        grid.innerHTML='';
        grid.style.display='none';
        if(empty) empty.style.display='block';
        return;
      }
      var currency=window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active?window.Shopify.currency.active:'EGP';
      grid.innerHTML=valid.map(function(p){
        var img=p.featured_image?p.featured_image.replace(/^https?:/,''):'';
        var imgStyle=img?'background-image:url('+img+');':'';
        var price=fmtPrice(p.price, currency);
        return '<article class="ccb-wishlist-card">'+
               '<a href="/products/'+p.handle+'" class="ccb-wishlist-card__media" aria-label="'+p.title+'">'+
               '<div class="ccb-wishlist-card__image" style="'+imgStyle+'"></div>'+
               '</a>'+
               '<button type="button" class="ccb-heart is-saved ccb-wishlist-card__heart" data-handle="'+p.handle+'" aria-label="Remove from wishlist">'+HEART_FILLED+'</button>'+
               '<a href="/products/'+p.handle+'" class="ccb-wishlist-card__name">'+p.title+'</a>'+
               '<p class="ccb-wishlist-card__price">'+price+'</p>'+
               '</article>';
      }).join('');
      grid.dataset.loaded='1';
      grid.querySelectorAll('.ccb-wishlist-card__heart').forEach(function(btn){
        btn.addEventListener('click',function(e){
          e.preventDefault(); e.stopPropagation();
          var handle=btn.getAttribute('data-handle');
          toggle(handle);
          var card=btn.closest('.ccb-wishlist-card');
          if(card){ card.style.opacity='0'; card.style.transition='opacity 0.25s ease'; }
          setTimeout(renderWishlistPage,260);
        });
      });
    });
  }

  document.addEventListener('ccb:wishlist:changed',function(){
    updateHeaderCount();
    if(document.getElementById('ccb-wishlist-grid')){ renderWishlistPage(); }
  });

  function init(){
    injectHeaderHeart();
    injectCardHearts();
    injectPdpHeart();
    renderWishlistPage();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  var pending=false;
  var observer=new MutationObserver(function(){
    if(pending) return;
    pending=true;
    requestAnimationFrame(function(){
      injectCardHearts();
      injectHeaderHeart();
      injectPdpHeart();
      pending=false;
    });
  });
  observer.observe(document.body,{childList:true,subtree:true});

  window.CCBWishlist={get:getList,set:setList,toggle:toggle,clear:function(){setList([]);}};
})();
